import IncompleteAccountView from "../components/IncompleteAccountView/IncompleteAccountView";

export default function IncompleteAccountPage() {
    return <IncompleteAccountView />;
}
